import { createElement, ReactNode } from "react";

export const escapeRegExp = (s: string): string =>
  s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const highlightText = (text: string, highlight: string): ReactNode[] => {
  if (!highlight) return [text];

  const parts = text.split(new RegExp(`(${escapeRegExp(highlight)})`, "gi"));

  return parts.map((part, i) =>
    part.toLowerCase() === highlight.toLowerCase()
      ? createElement("strong", { key: i, style: { fontWeight: 700 } }, part)
      : createElement("span", { key: i }, part),
  );
};
